import {
  createRocheButtonTrackingObject,
  handleRocheButtonOnClick,
  useComponentTracking,
  useTranslation,
} from '@repo/roche-xx-shared';
import { RocheUIAddToCalendar } from '@rocheglobal/roche-ui';
import React, { FC } from 'react';

export interface RocheAddToCalendarProps {
  blok: {
    eventTitle: string;
    description: string;
    startDate: string;
    endDate: string;
  };
}

export const RocheAddToCalendar: FC<RocheAddToCalendarProps> = ({ blok }) => {
  const heading = useTranslation('select your calendar');
  const icsLabel = useTranslation('ICS File');
  const googleCalendarLabel = useTranslation('Google Calendar');
  const outlookOnlineLabel = useTranslation('Outlook Online');
  const { path } = useComponentTracking();

  return (
    <RocheUIAddToCalendar
      heading={heading}
      icsLabel={icsLabel}
      googleCalendarLabel={googleCalendarLabel}
      outlookOnlineLabel={outlookOnlineLabel}
      eventTitle={blok.eventTitle}
      description={blok.description}
      startDate={blok.startDate}
      endDate={blok.endDate}
      onCalendarLinkClick={(clickEvent, text, href) => {
        const trackingData = createRocheButtonTrackingObject({ text, componentPath: path, href });
        handleRocheButtonOnClick(clickEvent, trackingData);
      }}
    />
  );
};
